module.exports = __webpack_public_path__ + "assets/b38.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b38.png
// module id = 625
// module chunks = 0